export const SET_CLINICS_SUCCESS = "SET_CLINICS_SUCCESS";
